import { useState } from "react";
import { useNavigate } from "react-router-dom";

import CpAuthLayout from "layouts/CpAuthLayout";

import Step1Form from "components/cpSignup/Step1Form";
import Step2Form from "components/cpSignup/Step2Form";
import Step3Form from "components/cpSignup/Step3Form";
import ProfileCard from "components/cpSignup/ProfileCard";
import SignupSuccess from "./SignupSuccess";

export default function CpSignupPage() {
  const [step, setStep] = useState(1);
  const navigate = useNavigate();

  const [data, setData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    password: "",
    location: null,
    workingDistance: "",
    profileImage: null,
    role: "",
    yoe: "",
    hourlyRate: "",
    phone_number: "",
    bio: "",
    skills: [],
    equipments: [],
    certifications: [],
    featuredWork: [],
    links: [],
    portfolio: [],
  });

  const nextStep = () => setStep((s) => s + 1);
  const prevStep = () => setStep((s) => s - 1);

  const handleBack = () => {
    if (step === 1) {
      navigate("/");
    } else {
      prevStep();
    }
  };

  /* -------------------------------------------
     STEP 4 (Signup Success) – NO LAYOUT
  -------------------------------------------- */
  if (step === 4) {
    return <SignupSuccess data={data} />;
  }

  /* -------------------------------------------
     STEPS 1–3 (WITH CpAuthLayout)
  -------------------------------------------- */
  const renderStepForm = () => {
    switch (step) {
      case 1:
        return (
          <Step1Form
            data={data}
            setData={setData}
            nextStep={nextStep}
          />
        );

      case 2:
        return (
          <Step2Form
            data={data}
            setData={setData}
            nextStep={nextStep}
            prevStep={prevStep}
          />
        );

      case 3:
        return (
          <Step3Form
            data={data}
            setData={setData}
            nextStep={nextStep}
            prevStep={prevStep}
          />
        );

      default:
        return null;
    }
  };

  return (
    <CpAuthLayout
      step={`Step ${step}/3`}
      title={
        step === 1
          ? "Build Your Creative Profile"
          : step === 2
          ? "Professional Details"
          : "Social Engagement"
      }
      description={
        step === 1
          ? "Create your profile to get discovered by production teams."
          : step === 2
          ? "Create your profile to get discovered by production teams."
          : "Complete your profile and connect with top studios and filmmakers."
      }
      onBack={handleBack}
      leftContent={renderStepForm()}
      rightCardContent={<ProfileCard data={data} />}
    />
  );
}
